import router from "../router/router"
import { articleService } from "../services/Article.service";
import { MessageBox, Loading } from 'element-ui';
const state = {
    dataTable: [],
    current_article: {},
    total: 0
};

const actions = {
    async addArticle({ commit }, data) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await articleService.addArticle(data);
        if (result.status === 200) {
            if (result.data.status == 1) {
                articleService.sendNotification(result.data)
            }
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm('จัดเก็บข้อมูลเรียบร้อย', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(() => {
                router.push({ name: 'Manage_article' })
            }).catch(() => {
                router.push({ name: 'Manage_article' })
            });
        } else {
            setTimeout(function() { loadingInstance.close() }, 250)
            if (result.status === 230 || result.status === 225) {
                MessageBox.confirm(result.message, "แจ้งเตือน", {
                        confirmButtonText: "ตกลง",
                        showCancelButton: false,
                        type: "warning"
                    })
                    .then(() => {
                        $cookies.remove("user_nbtc");
                        router.push({
                            name: "Login"
                        });
                    })
                    .catch(() => {
                        $cookies.remove("user_nbtc");
                        router.push({
                            name: "Login"
                        });
                    });
            } else {
                MessageBox.confirm(result.message, "แจ้งเตือน", {
                        confirmButtonText: "ตกลง",
                        showCancelButton: false,
                        type: "warning"
                    })
                    .then(() => {})
                    .catch(() => {});
            }
        }
    },
    async searchArticle({ commit }, data) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await articleService.searchArticle(data);
        if (result.status === 200) {
            state.dataTable = []
            state.dataTable = result.data
            state.total = result.data.length > 0 ? result.data[0].total : 0
            setTimeout(function() { loadingInstance.close() }, 250)
        } else {
            setTimeout(function() { loadingInstance.close() }, 250)
            if (result.status === 230 || result.status === 225) {
                MessageBox.confirm(result.message, "แจ้งเตือน", {
                        confirmButtonText: "ตกลง",
                        showCancelButton: false,
                        type: "warning"
                    })
                    .then(() => {
                        $cookies.remove("user_nbtc");
                        router.push({
                            name: "Login"
                        });
                    })
                    .catch(() => {
                        $cookies.remove("user_nbtc");
                        router.push({
                            name: "Login"
                        });
                    });
            } else {
                MessageBox.confirm(result.message, "แจ้งเตือน", {
                        confirmButtonText: "ตกลง",
                        showCancelButton: false,
                        type: "warning"
                    })
                    .then(() => {})
                    .catch(() => {});
            }
        }
    },
    async getArticle({ commit }, data) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await articleService.getArticle(data);
        if (result.status === 200) {
            state.current_article = result.data[0]
            setTimeout(function() { loadingInstance.close() }, 250)
        } else {
            setTimeout(function() { loadingInstance.close() }, 250)
            if (result.status === 230 || result.status === 225) {
                MessageBox.confirm(result.message, "แจ้งเตือน", {
                        confirmButtonText: "ตกลง",
                        showCancelButton: false,
                        type: "warning"
                    })
                    .then(() => {
                        $cookies.remove("user_nbtc");
                        router.push({
                            name: "Login"
                        });
                    })
                    .catch(() => {
                        $cookies.remove("user_nbtc");
                        router.push({
                            name: "Login"
                        });
                    });
            } else {
                MessageBox.confirm(result.message, "แจ้งเตือน", {
                        confirmButtonText: "ตกลง",
                        showCancelButton: false,
                        type: "warning"
                    })
                    .then(() => {})
                    .catch(() => {});
            }
        }
    },
    async editArticle({ commit }, data) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await articleService.editArticle(data);
        if (result.status === 200) {
            setTimeout(function() { loadingInstance.close() }, 250)
            MessageBox.confirm('แก้ไขข้อมูลเรียบร้อย', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(() => {
                router.push({ name: 'Manage_article' })
            }).catch(() => {
                router.push({ name: 'Manage_article' })
            });
        } else {
            setTimeout(function() { loadingInstance.close() }, 250)
            if (result.status === 230 || result.status === 225) {
                MessageBox.confirm(result.message, "แจ้งเตือน", {
                        confirmButtonText: "ตกลง",
                        showCancelButton: false,
                        type: "warning"
                    })
                    .then(() => {
                        $cookies.remove("user_nbtc");
                        router.push({
                            name: "Login"
                        });
                    })
                    .catch(() => {
                        $cookies.remove("user_nbtc");
                        router.push({
                            name: "Login"
                        });
                    });
            } else {
                MessageBox.confirm(result.message, "แจ้งเตือน", {
                        confirmButtonText: "ตกลง",
                        showCancelButton: false,
                        type: "warning"
                    })
                    .then(() => {})
                    .catch(() => {});
            }
        }
    },
    async remove({ commit }, data) {
        let result = await articleService.remove(data);
        if (result.status === 200) {
            MessageBox.confirm('ลบข้อมูลเรียบร้อยแล้ว', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(() => {
                // commit('CUT_TABLE', data)
            }).catch(() => {
                // commit('CUT_TABLE', data)
            });
        } else {
            if (result.status === 230 || result.status === 225) {
                MessageBox.confirm(result.message, "แจ้งเตือน", {
                        confirmButtonText: "ตกลง",
                        showCancelButton: false,
                        type: "warning"
                    })
                    .then(() => {
                        $cookies.remove("user_nbtc");
                        router.push({
                            name: "Login"
                        });
                    })
                    .catch(() => {
                        $cookies.remove("user_nbtc");
                        router.push({
                            name: "Login"
                        });
                    });
            } else {
                MessageBox.confirm(result.message, "แจ้งเตือน", {
                        confirmButtonText: "ตกลง",
                        showCancelButton: false,
                        type: "warning"
                    })
                    .then(() => {})
                    .catch(() => {});
            }
        }
    }
};

const mutations = {
    CUT_TABLE(state, data) {
        let index = state.dataTable.findIndex(x => x.article_id === data);
        state.dataTable.splice(index, 1)
    }
};


export const articleStore = {
    namespaced: true,
    state,
    actions,
    mutations
};